import { render } from "./CreateAgendaSubKomunitasView.vue?vue&type=template&id=e4bc9e82"
import script from "./CreateAgendaSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./CreateAgendaSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__